import { render, staticRenderFns } from "./AdmFeeTable.vue?vue&type=template&id=500492ee&scoped=true&"
import script from "./AdmFeeTable.vue?vue&type=script&lang=js&"
export * from "./AdmFeeTable.vue?vue&type=script&lang=js&"
import style0 from "./AdmFeeTable.vue?vue&type=style&index=0&id=500492ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500492ee",
  null
  
)

export default component.exports